import { render, staticRenderFns } from "./tradingParticulars.vue?vue&type=template&id=02658806&scoped=true"
import script from "./tradingParticulars.vue?vue&type=script&lang=js"
export * from "./tradingParticulars.vue?vue&type=script&lang=js"
import style0 from "./tradingParticulars.vue?vue&type=style&index=0&id=02658806&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02658806",
  null
  
)

export default component.exports